import React from 'react';
import PropTypes from 'prop-types';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

const styles = theme => ({
  root: {
    height: 288,
    width: '100%',
    overflowY: 'auto'
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
});

class CheckboxList extends React.Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.state = {
      value: "",
      notes: []
    };
  }

  componentWillReceiveProps(nextProps) {
    /* Pré-rempli les notes */
    if(nextProps.notes.length > 0) {
      let data = nextProps.notes.map((note, index) => {
        return {id:index, description: note.description, status: note.status}
      });
      this.setState({notes: data});
    }
  }

  handleRemove(e, i) {
    let new_notes = this.state.notes.filter((note) => note.id !== i);
    this.setState(prevState => ({
      notes: new_notes,
      value: ""
    }), () => {
      this.props.handleInputChange({target: {name:"notes", value: this.state.notes.map(note=> {
        return {description: note.description, status: note.status}
      })}})
    })
  }

  handleFormSubmit(e) {
    e.preventDefault();
    this.setState(prevState => ({
      notes: [...prevState.notes, {id: this.state.notes.length, description: this.state.value, status:false}],
      value: ""
    }), () => {
      this.props.handleInputChange({target: {name:"notes", value: this.state.notes.map(note=> {
        return {description: note.description, status: note.status}
      })}})
    })

  }

  handleInputChange(e) {
    this.setState({
      value: e.target.value
    })
  }

  handleToggle(e, i) {
    let new_notes = [ ...this.state.notes ];
    new_notes.map(note => {
      if (note.id === i)
        note.status = !note.status
      return note
    })
    this.setState({
      notes: new_notes
    }, () => {
      this.props.handleInputChange({target: {name:"notes", value: this.state.notes.map(note=> {
        return {description: note.description, status: note.status}
      })}})
    })

  };

  render() {
    const { classes } = this.props;
    return (
      <div>
      {this.state.notes.length > 0 && (
        <List className={classes.root}>
          {this.state.notes.map(note => (
            <ListItem
              id={note.id}
              key={note.id}
              role={undefined}
              dense
              button
              onClick={(e) => this.handleToggle(e, note.id)}
              className={classes.listItem}
            >
              <Checkbox
                checked={note.status}
                tabIndex={-1}
                disableRipple
              />
              <ListItemText primary={note.description} />
              <ListItemSecondaryAction>
                <IconButton aria-label="Supprimer" onClick={(e) => this.handleRemove(e, note.id)}>
                  <DeleteOutlineIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
        )}
        <ValidatorForm onSubmit={this.handleFormSubmit} className={this.props.classes.form}>
        <FormControl margin="normal" required fullWidth>
            <TextValidator
                label="Note"
                onChange={this.handleInputChange}
                name="note"
                value={this.state.value}
                validators={['required']}
                errorMessages={['ce champ est requis']}
            />
        </FormControl>
          <Button
              type="submit"
              variant="raised"
              color="default"
              className={classes.submit}
          >
              Ajouter
          </Button>
        </ValidatorForm>
      </div>
    );
  }
}

CheckboxList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CheckboxList);



// WEBPACK FOOTER //
// ./src/component/utils/CheckboxList.js